"use client";

import { TooltipProvider } from "@workspace/ui/components/tooltip";
import { SessionProvider } from "next-auth/react";
import { NuqsAdapter } from "@workspace/ui/components/nuqs-adapter";
import { ThemeProvider } from "next-themes";

import { PropsWithChildren } from "react";

// Lazy load heavy providers
import QueryProvider from "./query-provider";

export const Providers = ({ children }: PropsWithChildren) => {
  return (
    <ThemeProvider attribute="class" defaultTheme="dark" forcedTheme="dark" enableSystem={false}>
      <NuqsAdapter>
        <QueryProvider>
          <SessionProvider>
            <TooltipProvider>{children}</TooltipProvider>
          </SessionProvider>
        </QueryProvider>
      </NuqsAdapter>
    </ThemeProvider>
  );
};
